import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchCustomerById, saveOrUpdateCustomer } from '../../api/CustomerApi'; // Import hooks for routing and navigation

const CustomerPage: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // Extract customer ID from URL parameters
  const navigate = useNavigate(); // Hook to handle navigation
  const [customer, setCustomer] = useState<{ id: number; name: string } | null>(
    null
  );
  const [name, setName] = useState<string>('');
  const [originalName, setOriginalName] = useState<string>(''); // Track original name for comparison
  const [error, setError] = useState<string | null>(null);
  const isNewCustomer = !id;

  useEffect(() => {
    if (!isNewCustomer) {
      const loadCustomer = async () => {
        try {
          const data = await fetchCustomerById(Number(id));
          setCustomer(data);
          setName(data.name);
          setOriginalName(data.name); // Set original name
        } catch (err) {
          setError('Failed to load customer');
        }
      };

      loadCustomer();
    }
  }, [id, isNewCustomer]);

  const handleSave = async () => {
    try {
      await saveOrUpdateCustomer({ id: customer?.id || 0, name });
      navigate('/customers'); // Redirect to the customer list page
    } catch (err) {
      setError('Failed to save customer');
    }
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  // Enable save button if the name has changed from the original value
  const isSaveDisabled = !name || name === originalName;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={handleSave} disabled={isSaveDisabled}>
          Save
        </button>
      </div>
      <h1>{isNewCustomer ? 'Create New Customer' : 'Customer Details'}</h1>
      {error && <div>{error}</div>}
      <div>
        <label>
          Name:
          <input type="text" value={name} onChange={handleNameChange} />
        </label>
      </div>
    </div>
  );
};

export default CustomerPage;
